import { Tag } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import { PriceWithDiscountDisplay } from "~/components/blocks/product/common/blocks/price-with-discount-display";
import type {
  G_VideoFreeProduct,
  G_VideoSvodProduct,
  Maybe,
  G_VideoPpvExpiration,
  G_GetVideoMainEpisodeQuery,
} from "~/lib/graphql";
import { G_ServicePlan } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

type EpisodeTagProps = {
  freeProduct?: Maybe<Pick<G_VideoFreeProduct, "contentId">>;
  svodProduct?: Maybe<Pick<G_VideoSvodProduct, "contentId">>;
  priceSummary?: G_GetVideoMainEpisodeQuery["video"]["episodes"]["edges"][number]["node"]["priceSummary"];
  ppvExpiration?: Maybe<G_VideoPpvExpiration>;
};

/** 特典映像タブとエピソードタブのTagの出し分けに使用するコンポーネント */
export const EpisodeTag = memo((props: EpisodeTagProps) => {
  const { freeProduct, svodProduct, priceSummary, ppvExpiration } = props;

  const { servicePlan } = useAuth();

  const isFreeEpisode = freeProduct !== undefined && freeProduct !== null;

  const isPremiumEpisode = svodProduct !== undefined && svodProduct !== null;

  const isPpvEpisode = priceSummary !== undefined && priceSummary !== null;

  if (ppvExpiration !== undefined && ppvExpiration !== null) {
    return <Tag tagText="購入済み" color="BLUE900" borderColor="BLUE900" />;
  }

  if (isFreeEpisode) {
    if (servicePlan === G_ServicePlan.Premium) return null;
    return <Tag tagText="無料" color="GRAY1000" borderColor="GRAY1000" />;
  }

  if (isPremiumEpisode) {
    return <Tag tagText="プレミアム" color="YELLOW50" borderColor="YELLOW50" />;
  }

  if (isPpvEpisode) {
    return <PriceWithDiscountDisplay priceSummary={priceSummary} />;
  }

  return null;
});

EpisodeTag.displayName = "EpisodeTag";
